import * as React from 'react'
import { SVGProps } from 'react'
const SvgIdrLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 200 200"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    {...props}
  >
    <path
      d="M100 200c55.228 0 100-44.772 100-100S155.228 0 100 0 0 44.772 0 100s44.772 100 100 100Z"
      fill="#F21616"
    />
    <path
      d="M55 115.878V80.002h9.49v35.876H55ZM75.918 115.878V80.002h10.583c2.528-.03 5.047.306 7.478.996 2.15.6 4.139 1.673 5.821 3.14a14.417 14.417 0 0 1 3.784 5.52 21.813 21.813 0 0 1 1.349 8.114 22.622 22.622 0 0 1-1.323 8.167 14.745 14.745 0 0 1-3.722 5.635 15.03 15.03 0 0 1-5.688 3.254 23.436 23.436 0 0 1-7.144 1.05H75.918Zm9.498-7.62h.582c1.23.011 2.455-.146 3.642-.467a6.85 6.85 0 0 0 2.955-1.632 7.73 7.73 0 0 0 1.958-3.201c.53-1.676.775-3.429.723-5.186a15.17 15.17 0 0 0-.723-5.132 7.337 7.337 0 0 0-1.958-3.087 6.658 6.658 0 0 0-2.954-1.517 15.107 15.107 0 0 0-3.643-.415h-.547l-.035 20.637ZM113.267 115.878V80.002h13.581a26.972 26.972 0 0 1 5.486.547c1.636.322 3.194.96 4.585 1.878a9.498 9.498 0 0 1 3.122 3.528 12.164 12.164 0 0 1 1.156 5.6 11.957 11.957 0 0 1-1.57 6.403 11.16 11.16 0 0 1-4.224 3.977l7.778 13.908h-10.583l-6.173-12.029h-3.643v12.064h-9.515Zm9.498-19.543h3.422c3.827 0 5.741-1.581 5.741-4.745a3.445 3.445 0 0 0-1.464-3.2 8.387 8.387 0 0 0-4.277-.883h-3.422v8.828ZM166.346 138.76A76.821 76.821 0 0 1 100 176.862a76.817 76.817 0 0 1-66.346-38.102H27.55a82.175 82.175 0 0 0 114.674 31.715 82.175 82.175 0 0 0 30.224-31.715h-6.103ZM33.654 61.24a76.814 76.814 0 0 1 132.692 0h6.103a82.176 82.176 0 0 0-144.898 0h6.103Z"
      fill="#fff"
    />
  </svg>
)
export default SvgIdrLogo
